import {FC, Key, useMemo} from 'react';
import {isMobile} from 'react-device-detect';
import {useSelector} from 'react-redux';
import cn from 'classnames';

import BonusCard from '../../components/BonusCard';
import { getMyBonusesData , getSelectedGameBoxTag } from '../../store/selectors';
import Missions from '../Missions';

import 'swiper/css';
import './styles.scss';

interface GameBoxInformationProps {
    data: any;
    isFunMission?: any;
    isLandscape?: boolean;
    onClose: () => void;
    gameBoxWidgetVisibilityHandler?: (st?: boolean) => void;
}

const GameBoxInformation: FC<GameBoxInformationProps> = ({ data, isFunMission, isLandscape, onClose, gameBoxWidgetVisibilityHandler }) => {
    const selectedGameBoxTag = useSelector(getSelectedGameBoxTag);
    const missionData = useSelector(getMyBonusesData);

    const renderedMissions = useMemo(() => {
        const missions = missionData[selectedGameBoxTag];
        if (!missions?.length) return null;
        return missions.map((data: { submissions: string[]; id: Key }, index: number) => {
            const showIndex = missions.length >= 2 ? `${index + 1} / ${missions.length}` : null;
            return (
                <div key={data.id || index} className={cn({
                    'submissions-slider': data?.submissions?.length,
                    'without-slider': !data?.submissions?.length })}
                >
                    <p className='card-index'>{showIndex}</p>
                    {data?.submissions?.length ? (
                        <Missions data={data} isLandscape={isLandscape} onClose={onClose} gameBoxWidgetVisibilityHandler={gameBoxWidgetVisibilityHandler} />
                    ) : (
                        <BonusCard data={data} onClose={onClose} gameBoxWidgetVisibilityHandler={gameBoxWidgetVisibilityHandler} />
                    )}
                </div>
            );
        });
    }, [isLandscape, missionData, selectedGameBoxTag]);

    return (
        <div
            className={cn('game-box-widget-info-wrapper', {
                mobile: isMobile,
            })}
        >
            <div className="game-box-widget-info">
                <div className={cn('game-box-widget__container', {
                    'landscape__raffle': isMobile && isLandscape && selectedGameBoxTag === 'raffle',
                    'landscape__separateRaffle': isMobile && isLandscape && selectedGameBoxTag === 'raffle' && data?.length > 1,
                })}>
                    {/*{selectedGameBoxTag === 'raffle' &&
                        data?.length > 0 && data.map((raffleMission: any, index: Key) => (
                            <RaffleDrawTicketsInfoWidget data={raffleMission} key={index} />
                        ))
                    }*/}
                    {selectedGameBoxTag === 'funMission' && isFunMission && <BonusCard data={isFunMission} onClose={onClose} inGame={true} />}
                </div>
                <div className="game-box-widget-info--card-section">{renderedMissions}</div>
            </div>
        </div>
    );
};

export default GameBoxInformation;
